import React from "react";
import { SiFreelancer, SiFiverr, SiToptal, SiReactivex } from "react-icons/si";
import { TbLetterA } from "react-icons/tb";
import { MdWork } from "react-icons/md";
import ExperienceCard from "./ExperienceCard";

const Experience = ({ theme }) => {
  return (
    <div
      className={`${
        theme === "dark" ? "border-darkLineColor" : "border-lightLineColor"
      } py-10 xl:py-20 border-b-[1px] group`}
    >
      <h3
        className={`${
          theme === "dark" ? "text-darkTextColor" : "text-lightTextColor"
        } text-[32px] flex flex-row justify-center lgl:justify-start items-center gap-4 text-center lgl:text-left font-bold`}
      >
        Experience
        <span>
          <MdWork className="text-iconColor group-hover:animate-pulse" />
        </span>
      </h3>
      <div className="py-10 grid grid-cols-1 md:grid-cols-2 place-content-between gap-6 xl:gap-10">
        <ExperienceCard
          icon={<TbLetterA />}
          title="Arogga.com"
          des="Software Engineer 2023 - Present"
          theme={theme}
        />
        <ExperienceCard
          icon={<SiReactivex />}
          title="ReactBD.com"
          des="CEO  2021 - Present"
          theme={theme}
        />
        <ExperienceCard
          icon={<SiFreelancer />}
          title="Freelancer"
          des="MERN Stack Developer 2020 - 2021"
          theme={theme}
        />
        <ExperienceCard
          icon={<SiToptal />}
          title="Toptal"
          des="MERN Stack Developer 2021 - present"
          theme={theme}
        />
        <ExperienceCard
          icon={<SiFiverr />}
          title="Fiverr"
          des="MERN Stack Developer 2019 - 2020"
          theme={theme}
        />
      </div>
    </div>
  );
};

export default Experience;
